/* eslint-disable no-console */
import { Codes, Dto } from '@lmc/ts-common/lib/utils/errors'
import * as Sentry from '@sentry/react'
import CONSTANTS from 'utils/constants'
import { getQueryParams } from 'utils/getQueryParams'

const isBrowserEnv = (): boolean => {
  if (window) {
    return true
  }

  return false
}

const checkIfBrowser = () => {
  const isBrowser: boolean = isBrowserEnv()

  if (!isBrowser) {
    throw new Error('This is not a browser env')
  }
}

const ssoLogin = async () => {
  const redirectUri = `${window.location.origin}${window.location.pathname}`

  const params = {
    client_id: CONSTANTS.VITE_FUSIONAUTH_APP_CO_CLIENT_ID,
    redirectUri,
    scope: 'offline_access',
  }

  const queryParams = getQueryParams(params)

  checkIfBrowser()

  window.location.href = `${CONSTANTS.VITE_API_CM_URL_PROXY}/v5/auth/login?${queryParams}`
}

export const ssoLogout = async () => {
  Sentry.setUser(null)

  checkIfBrowser()

  window.location.href = `${
    CONSTANTS.VITE_APP_CM_API
  }/auth/logout?${new URLSearchParams({
    client_id: CONSTANTS.VITE_FUSIONAUTH_APP_CO_CLIENT_ID,
  })}`
}

export const ssoMiddleware = async (response: Response) => {
  if (response.status === 401) {
    await ssoLogin()
  }
}

export const checkMFAForce = async (response: Dto) => {
  if (
    response.code === Codes.mfaIsMissingWhenFeatureIsEnabled &&
    window.location.pathname !== '/mfa'
  ) {
    window.location.replace('/mfa')
  }
}
